// src/utils/sessionId.js
// Identifiant aléatoire d'une session de navigation (onglet), sans lien avec l'utilisateur.
// Joint à chaque événement de monitoring : permet de reconstituer ce qui précède un crash.
let memoryId = null;

export function getSessionId() {
  try {
    let id = sessionStorage.getItem('drumigo-session-id');
    if (!id) {
      id = Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-4);
      sessionStorage.setItem('drumigo-session-id', id);
    }
    return id;
  } catch {
    if (!memoryId) memoryId = Math.random().toString(36).slice(2, 12);
    return memoryId;
  }
}
